import Header from "../Header";
import AdminPanelSideBar from "./AdminPanelSideBar";
import UserPosts from "../Posts/UserPosts";
import Footer from "../Footer";
import { NavLink, useLocation } from "react-router-dom";

const AdminPosts = () => {
  const location = useLocation();

  return (
    <>
      <Header />
      <div className="below-header">
        <p>
          <NavLink to={"/"}>Home</NavLink>
          <span>/</span>
          <a href={location.pathname} className="aCustom">My Posts</a>
        </p>
      </div>
      <div className="flex-screen custom_section">
        <AdminPanelSideBar />
        <UserPosts />
      </div>
      <Footer />
    </>
  );
};

export default AdminPosts;
